export const ADMIN = 'group:admin';
export const SUPER_ADMIN = 'group:super_admin';
export const ATLAS_ADMIN = 'group:atlas:admin';
export const CDX_REPORTING_ADMIN = 'group:cdx:reporting_admin';
export const BILLING_SPECIALIST = 'group:compass:billing_specialist';
export const SALES = 'group:sales';
export const OFFSHORE_CS = 'group:care_support_offshore';
export const CARE_SUPPORT_ELEVATED = 'group:care_support_elevated';
export const CARE_SUPPORT = 'group:care_support';
export const CUSTOMER_SUCCESS_ELEVATED = 'group:customer_success_elevated';
export const CUSTOMER_SUCCESS = 'group:customer_success';
export const MAINTENANCE_TASK_RUNNER = 'group:maintenance_task_runner';
export const MARKETING = 'group:marketing';
export const HEALTH_PLAN_OPS = 'group:health_plan_ops';
export const HEALTH_PLAN_OPS_ELEVATED = 'group:health_plan_ops_elevated';
export const IMPLEMENTATION_ELEVATED = 'group:implementation_elevated';
export const IMPLEMENTATION_TECH_OPS = 'group:implementation_tech_ops';
export const IMPLEMENTATION = 'group:implementation';
export const INFORMATION_TECHNOLOGY = 'group:information_technology';
export const RESEARCH_AND_DEVELOPMENT = 'group:research_and_development';
export const RESEARCH_AND_DEVELOPMENT_ELEVATED = 'group:research_and_development_elevated';
export const PROVIDER_OPS = 'group:provider_ops';
export const PROVIDER_OPS_ELEVATED = 'group:provider_ops_elevated';
export const PROVIDER_SUCCESS_AND_ONBOARDING = 'group:provider_success_and_onboarding';
export const CARE_NAVIGATION_SPECIALTY_CARE = 'group:care_navigation_specialty_care';
export const CARE_NAVIGATION_SPECIALTY_CARE_ELEVATED = 'group:care_navigation_specialty_care_elevated';
export const POPS_ENGINEER = 'group:pops_engineer';
export const ENGINEERING = 'group:engineering';

export const ADMIN_PORTAL_ROLES = [
  ADMIN,
  SUPER_ADMIN,
  OFFSHORE_CS,
  CARE_SUPPORT_ELEVATED,
  CARE_SUPPORT,
  CUSTOMER_SUCCESS_ELEVATED,
  CUSTOMER_SUCCESS,
  SALES,
  HEALTH_PLAN_OPS,
  HEALTH_PLAN_OPS_ELEVATED,
  IMPLEMENTATION_ELEVATED,
  IMPLEMENTATION_TECH_OPS,
  IMPLEMENTATION,
  INFORMATION_TECHNOLOGY,
  MARKETING,
  CARE_NAVIGATION_SPECIALTY_CARE,
  CARE_NAVIGATION_SPECIALTY_CARE_ELEVATED,
  PROVIDER_OPS,
  PROVIDER_OPS_ELEVATED,
  PROVIDER_SUCCESS_AND_ONBOARDING,
  RESEARCH_AND_DEVELOPMENT,
  RESEARCH_AND_DEVELOPMENT_ELEVATED,
  POPS_ENGINEER,
  ENGINEERING,
];

// Make sure this always match compass roles
const COMPASS_ROLES = [
  'group:compass:care_provider',
  'group:compass:associate_provider',
  'group:compass:med_manager',
  'group:compass:care_navigator',
  'group:compass:admin',
  'group:compass:clinical_manager',
  'group:compass:billing_specialist',
  'group:compass:care_advocate',
  'group:compass:peer_recovery_specialist',
  'group:compass:employee_consultant',
];

export const ALLOWED_SCOPES = [
  ATLAS_ADMIN,
  CDX_REPORTING_ADMIN,
  ...ADMIN_PORTAL_ROLES,
  ...COMPASS_ROLES,
  MAINTENANCE_TASK_RUNNER,
];
